import { connect } from 'react-redux';

import { selectActiveVenueId, selectUserHasCPEmail } from 'selectors/general';

import { goToItem as goToItemAction } from '../../ManageServices.saga';
import { selectPractitioners } from '../../Practitioners/Practitioners.selectors';
import { selectResources } from '../../Resources/Resources.selectors';
import { updateService as updateServiceAction, deleteService as deleteServiceAction } from '../Services.saga';
import { selectSelectedServiceId } from '../Services.selectors';
import { messages } from '../Services.messages';
import ServiceForm from './ServiceForm';

export const mapStateToProps = (state, ownProps) => {
  const id = selectSelectedServiceId(state);
  const practitioners = selectPractitioners(state);
  const resources = selectResources(state);

  return {
    ...ownProps,
    id,
    isEditing: true,
    showDeleteButton: !!id && selectUserHasCPEmail(state),
    title: messages.form.editService,
    practitioners: practitioners.map(({ id: practitionerId, firstName, lastName, recurrence }) => ({
      id: practitionerId,
      name: firstName ? `${firstName} ${lastName}` : lastName,
      recurrence,
    })),
    resources: resources.map(({ id: resourceId, name: resourceName, recurrence }) => ({
      id: resourceId,
      name: resourceName,
      recurrence,
    })),
    venueId: selectActiveVenueId(state),
  };
};

const mapDispatchToProps = {
  deleteService: deleteServiceAction,
  goToItem: goToItemAction,
  updateService: updateServiceAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { id, ...restStateProps } = stateProps;
  const { updateService, deleteService, goToItem, ...restDispatchProps } = dispatchProps;
  return {
    ...restStateProps,
    ...restDispatchProps,
    handleDelete: deleteService.bind(null, id),
    handleCancel: goToItem.bind(null, id),
    handleSubmit: (formValues, formAsyncFns) => updateService({ ...formValues, id }, formAsyncFns),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ServiceForm);
